import type { AxiosError } from 'axios'
import { isAborted, messageOf } from '@/libraries/axios'
import { error } from '@/libraries/toast'

/* `messages` replaces the toast text for the HTTP statuses it names. */
export async function call<T>(
  run: () => Promise<{ data: T }>,
  fallback: T,
  messages: Partial<Record<number, string>> = {},
): Promise<T> {
  try {
    return (await run()).data
  } catch (failure) {
    if (isAborted(failure)) return fallback
    const status = (failure as AxiosError)?.response?.status
    error((status && messages[status]) || messageOf(failure))
    return fallback
  }
}

/* An empty list when the call fails or answers anything but a list. */
export async function rows<T>(
  run: () => Promise<{ data: T[] }>,
  messages: Partial<Record<number, string>> = {},
): Promise<T[]> {
  const data = await call(run, [], messages)
  return Array.isArray(data) ? data : []
}

export async function attempt(run: () => Promise<unknown>): Promise<boolean> {
  return call(() => run().then(() => ({ data: true })), false)
}
